import "../../../../content/projects/krauta/krauta.css";
import * as React from 'react';
export default {
  React
};